import PropTypes from 'prop-types';
import { Container, FlexGrid, Image } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import styles from './GasbackLandingGuide.module.css';
import GuideStep from './GuideStep';
import GetTheAppButton from '../GetTheAppButton';
import { gasbackLandingPageSteps } from '../../constants/guideSteps';
import { noop } from '../../../lib/utils';

const cx = classnames.bind(styles);

export default function GasBackLandingGuide({ className, onButtonClick }) {
  return (
    <Container>
      <FlexGrid className={cx('guideContainer', className)}>
        <FlexGrid.Column mobile={12} tablet={5} desktop={6} className={cx('gasBackPhoneContainer')}>
          <span className={cx('verticalCenterHelper')} />
          <div className={cx('phoneComp')}>
            <Image
              className={cx('gif')}
              src="https://static.gasbuddy.com/web/consumer/phones/iphone_X_content_screens_gasback.gif"
              alt="GasBuddy App"
            />
            <Image
              src="https://static.gasbuddy.com/web/consumer/phones/iphone_X_frame.png"
              webpSrcSet="https://static.gasbuddy.com/web/consumer/phones/iphone_X_frame.webp"
              alt="GasBuddy App"
            />
          </div>
        </FlexGrid.Column>
        <FlexGrid.Column mobile={12} tablet={7} desktop={6}>
          {gasbackLandingPageSteps.map(step => (
            <GuideStep key={step.stepText} step={step} />
          ))}
          <FlexGrid className={cx('underStepsSection')}>
            <FlexGrid.Column mobile={12} tablet={10} tabletOffset={2}>
              <GetTheAppButton onClick={onButtonClick} />
            </FlexGrid.Column>
          </FlexGrid>
        </FlexGrid.Column>
      </FlexGrid>
    </Container>
  );
}

GasBackLandingGuide.propTypes = {
  className: PropTypes.string,
  onButtonClick: PropTypes.func,
};

GasBackLandingGuide.defaultProps = {
  className: undefined,
  onButtonClick: noop,
};
